'use strict';

import Backbone from 'backbone';
import SingleBuyingOptionsRegionCollection from './SingleBuyingOptionsRegionCollection';

export default class SingleBuyingOptionsModel extends Backbone.Model {
  defaults() {
    return {
      isInCart: false,
      isValid: true,
      isPurchasable: false,
      inputQuantity: '',
      parsedQuantity: 0,
      quantities: {},
      calculatedQuantities: {},
      errors: [],
      friendlyErrors: [],
      totalPrice: '',
      currentRegion: null,
      regions: [],
      backorder: 0
    };
  }

  /**
   * Override set so that can ensure the collection class is used.
   *
   * @param {object} attributes
   * @param {Backbone.ModelSetOptions} [options]
   * @returns {SingleBuyingOptionsModel}
   */
  set(attributes, options) {
    if (attributes.regions && !(attributes.regions instanceof SingleBuyingOptionsRegionCollection)) {
      attributes.regions = new SingleBuyingOptionsRegionCollection(attributes.regions);
    }
    return super.set(attributes, options);
  }

  /**
   * Bootstrap the model.
   *
   * @param {object[]} regions
   */
  bootstrap(regions) {
    this.set({ regions });

    let firstRegion = this.get('regions').first();
    let currentRegion = firstRegion ? firstRegion.get('inventoryRegion') : null;
    let productIsDiscontinued = firstRegion ? firstRegion.get('productIsDiscontinued') : null;
    this.set({ currentRegion });
    this.set({ productIsDiscontinued });
    return this;
  }

  /**
   * Get all the add to cart buying options for the current region.
   *
   * @returns {SingleBuyingOptionCollection}
   */
  getAddToCartBuyingOptionsForCurrentRegion() {
    return this.get('regions').getAddToCartOptionsForRegion(this.get('currentRegion'));
  }

  /**
   * Get all the add to cart buying options for all region.
   *
   * @returns {SingleBuyingOptionCollection}
   */
  getAddToCartBuyingOptionsForAllRegion() {
    return this.get('regions').getAddToCartOptionsForAllRegion();
  }

  /**
   * Get the current region model.
   *
   * @returns {SingleBuyingOptionsRegionModel}
   */
  getCurrentRegionModel() {
    return this.get('regions').get(this.get('currentRegion'));
  }

  /**
   * Get all regions buying options.
   *
   * @returns {SingleBuyingOptionCollection}
   */
  getBuyingOptions() {
    return this.get('regions').getBuyingOptions();
  }

  /**
   * Get all addToCartOptions across all regions.
   *
   * @returns {SingleBuyingOptionCollection|null}
   */
  getAddToCartBuyingOptions() {
    return this.get('regions').getAddToCartOptions();
  }

  /**
   * Get the part ID.
   *
   * @returns {string}
   */
  getPartId() {
    return this.getBuyingOptions().first().get('partId').toString();
  }

  /**
   * Get the part number.
   *
   * @returns {string}
   */
  getPartNumber() {
    return this.getBuyingOptions().first().get('partNumber');
  }

  /**
   * Get all the buying options for a given region.
   *
   * @param {string} region
   * @returns {SingleBuyingOptionCollection}
   */
  getBuyingOptionsForRegion(region) {
    return this.get('regions').get(region).get('buyingOptions');
  }

  /**
   * Get current regions buying options.
   *
   * @returns {SingleBuyingOptionCollection}
   */
  getBuyingOptionsForCurrentRegion() {
    return this.getBuyingOptionsForRegion(this.get('currentRegion'));
  }

  /**
   * Look for a given sourcePartId across all regions
   *
   * @param {String} sourcePartId
   * @returns {SingleBuyingOptionsModel|undefined}
   */
  getBuyingOption(sourcePartId) {
    return this.getBuyingOptions().get(sourcePartId);
  }

  /**
   * Check if any region has an add to cart option.
   *
   * @returns {boolean}
   */
  hasAddToCartOptions() {
    return !!this.getAddToCartBuyingOptions().length;
  }

  /**
   * Check if current region has an add to cart option.
   *
   * @returns {boolean}
   */
  hasCurrentRegionAddToCartOptions() {
    return !!this.getAddToCartBuyingOptionsForCurrentRegion().length;
  }

  /**
   * Get the price bands for a given sourcePartId.
   *
   * @param {string} sourcePartId
   * @returns {PriceBand[]}
   */
  getPriceBandsBySourcePartId(sourcePartId) {
    return this.getBuyingOption(sourcePartId).get('priceBands');
  }

  /**
   * Get the first region
   *
   * @returns {SingleBuyingOptionsRegionModel|boolean}
   */
  getFirstRegion() {
    let regions = this.get('regions');

    if (regions && regions.length) {
      return regions.at(0);
    }

    return false;
  }

  /**
   * Checks if the buying option is Custom/Arrow reelable part
   *
   * @returns {BuyingOptionModel|boolean}
   */
  isPartReelable(sourcePartId) {
    let addToCartOptions = this.getAddToCartBuyingOptionsForCurrentRegion();
    let buyingOptions = addToCartOptions.models;
    let isArrowReel = false;
    _.forEach(buyingOptions, (buyingOptionModel) => {
      let sourcePartIdItem = buyingOptionModel.get('sourcePartId');
      if (sourcePartId === sourcePartIdItem) {
        isArrowReel = buyingOptionModel.get('isArrowReel');
      }
    });

    return isArrowReel;
  }

  /**
   * Gets the custom reel buying option for the current region
   *
   * @returns {BuyingOptionModel}
   */
  getArrowReelBuyingOptionForCurrentRegion() {
    return this.getAddToCartBuyingOptionsForCurrentRegion().find(x => x.get('isArrowReel'));
  }

  /**
   * Get the first regions first buying option
   *
   * @returns {BuyingOptionModel|boolean}
   */
  getFirstBuyingOption() {
    let region = this.getFirstRegion();

    if (region) {
      let buyingOptions = region.get('buyingOptions');

      if (buyingOptions && buyingOptions.length) {
        return buyingOptions.at(0);
      }
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./assets/components/SingleBuyingOptions/SingleBuyingOptionsModel.js